<template>
 <div>
  <!--  -->
  <EchoLastData
       :dataList="allPreview"
       :model="renderData.model.topPreviewModel"
     />
  <Success>
    <div slot="content">
      <div class="tip">
        已完成批量子订单创建，签约提车流程最后<span class="tip_num"> 2 </span>步需针对单台车进行，可点击操作快速前往
      </div>
    <stepList @setStepList="setStepList" :stepInfo="stepInfo"></stepList>
    <el-button @click="close">关闭</el-button>
    </div>

  </Success>
 </div>
</template>

<script>
import Success from '../../../components/Success.vue'
import stepList from './stepList.vue'
import EchoLastData from '../../../components/EchoLastData.vue'
import { allPreview } from '../../config/echoLastData'

export default {
  components: {
    Success,
    stepList,
    EchoLastData,
  },
  props: {
    renderData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      allPreview,
      stepInfo: [
        { status: '订单支付', active: 0 },
        { status: '发车验车', active: 1, hiddenLink: true },
        { status: '子订单开始履约', active: 2 },
      ],
    }
  },
  methods: {
    // 点击前往
    setStepList(index) {
      const path = '/car_to_lease/forRentSignContract'
      const { selectOrderFormModel } = this.renderData.model
      // 3:订单支付，4:发车验车
      if (index === 0) {
        this.$router.push({
          path,
          query: {
            activeName: 'child', // 子订单
            childActiveName: '13',
            entRentOrderId: selectOrderFormModel.entRentOrderId || '',
          },
        })
      }
      if (index === 1) {
        this.$router.push({
          path,
          query: {
            activeName: 'child',
            childActiveName: '12',
            entRentOrderId: selectOrderFormModel.entRentOrderId || '',
          },
        })
      }
      // const active = index === 0 ? 3 : 4
      // this.$emit('setStepList', active)
    },
    close() {
      this.$refreshBack() // 关闭当前tab
    },
  },
}
</script>

<style scoped lang='scss'>
.tip{
margin: 30px 0;
font-weight: bold;
}
.tip_num{
  color: #3d74dd;
}
</style>
